module.exports = __webpack_public_path__ + "static/media/PAUTO.d8f70862.png";